import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import { CSSProperties } from 'react';
import OnboardingMobileLayout from './OnboardingMobileLayout';
import OnboardingDesktopLayout from './OnboardingDesktopLayout';
import NavHeader from '../../../../common/NavHeader';

export interface OnboardingLayoutProps {
  children?: JSX.Element,
  reduceMobileTopPadding?: boolean;
  optionalDesktopContainerStyle?: CSSProperties;
  customDesktopBanner?: JSX.Element | null
  customStepper?: JSX.Element | null
}
export default function OnboardingLayout({
  children,
  reduceMobileTopPadding,
  optionalDesktopContainerStyle,
  customDesktopBanner,
  customStepper,
}: OnboardingLayoutProps) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <>
      <NavHeader />
      {customStepper && customStepper}
      {
        isDesktop ? <OnboardingDesktopLayout
          customBanner={customDesktopBanner}
          optionalDesktopContainerStyle={optionalDesktopContainerStyle}
        >
          {children}
        </OnboardingDesktopLayout> :
          <OnboardingMobileLayout reduceMobileTopPadding={reduceMobileTopPadding}>
            {children}
          </OnboardingMobileLayout>
      }
    </>
  );
}
